import reveal from './reveal';
global.reveal = reveal;

function initNavigation(navItem) {
    navItem = $(navItem);
    
    navItem.each(function(){
        let item = $(this);
        let navDropdown = item.find('.nav__dropdown');
        let dropdownexists = (navDropdown.length) ? true : false;
        
        if(dropdownexists === true) {
            item.children('a').append('<span class="far fa-chevron-down nav__arrow"></span>').attr('data-reveal-type', 'slide');
            reveal.initReveal(item.children('a'), navDropdown, '', false);
        } else {
        }
    });
}

function initSearch(trigger, search, close) {
    trigger = $(trigger);
    search = $(search);
    close = $(close);
    var formField = search.find('.form__input').first();
    var backdrop = '<div class="form--flyout__backdrop js-backdrop"></div>';
    
    trigger
        .attr({
            'role': 'button',
            'aria-expanded': 'false',
        });

    search
        .attr({
            'aria-hidden': 'true',
        }).find('.form__input, .form__submit').attr({
            'tabindex': '-1',
        });
    
    var toggleFocus = function(formField) {
        if(formField.hasClass('is-focused')) {
            formField.focus();
        } else {
            formField.blur();
        }
    };
    
    var toggleAttr = function(trigger, search) {
        if (trigger.hasClass('is-active')) {
            trigger.attr( 'aria-expanded', 'false');
        } else {
            trigger.attr( 'aria-expanded', 'true');
        }
        
        if (search.hasClass('is-active')) {
            search.attr({ 
                'aria-hidden': 'false',
            }).find('.form__input, .form__submit').attr({
                'tabindex': '0',
            });
        } else {
            search.attr({ 
                'aria-hidden': 'true',
            }).find('.form__input, .form__submit').attr({
                'tabindex': '-1',
            });
        }
    }
    
    var closeSearch = function() {
        trigger.removeClass('is-active');
        search.removeClass('is-active'); 
        formField.removeClass('is-focused');
        $('.js-backdrop').fadeOut().detach();
        
        toggleFocus(formField);
        toggleAttr(trigger, search);
    }
    
    trigger.on("click", function(e){
        e.preventDefault();
        $(this).toggleClass('is-active');
        search.toggleClass('is-active'); 
        formField.toggleClass('is-focused');
        $('body').append(backdrop);
        
        toggleFocus(formField);
        toggleAttr($(this), search);
    });
    
    close.on("click", function(e){
        e.preventDefault();
        closeSearch();
    });
    
    $(document).on('click', '.js-backdrop', function(e){
        e.preventDefault();
        closeSearch();
    });
}


$(document).ready(function () {
    initNavigation('.js-nav-item');
    initSearch('.js-toggle-search', '.js-search-form', '.js-close-search');
    
    $('.js-flyout-trigger').each(function(){
        let flyOut = $(this);
        reveal.initReveal(flyOut, flyOut.next('.js-flyout'), '', false);
    });
    
    $('.js-action-trigger').each(function(){
        let flyOut = $(this);
        reveal.initReveal(flyOut, flyOut.next('.js-action-flyout'), '', false);
    });
    
    $('.js-accordion-trigger').each(function(){
        let accordion = $(this);
        reveal.initReveal(accordion, accordion.next('.js-accordion-content'), '', false);
    });
    
    // get current URL path and assign 'active' class
	var pathname = window.location.pathname;
    var parentItem = $('.nav__item > a[href="'+pathname+'"]').parent();
	parentItem.addClass('is-current');
    if($('.nav__item > a[href="'+pathname+'"]').closest('.js-nav-item').length) {
        console.log('dfkjnfk');
        $('.nav__item > a[href="'+pathname+'"]').closest('.js-nav-item').children('a').click();
    }
});



// WEBPACK FOOTER //
// ./src/js/app.js